export class SortList {
  private orders: { [key: string]: string } = {};

  load(attribute: string): void {
    if (!this.orders[attribute]) {
      this.orders[attribute] = 'asc';
    } else if (this.orders[attribute] === 'asc') {
      this.orders[attribute] = 'desc';
    } else {
      delete this.orders[attribute];
    }
  }

  hasOrders(): boolean {
    return Object.keys(this.orders).length > 0;
  }

  toUrl(): string {
    return Object.entries(this.orders)
      .map(([key, value]) => `${key} ${value}`)
      .join(',');
  }

  getOrder(attribute: string): string | undefined {
    return this.orders[attribute];
  }
}
